var numberFormatAux = new Intl.NumberFormat('es-ES');
export const numberFormat = (number) => numberFormatAux.format(number);